import React from 'react';
import { Box, Typography } from '@mui/material';

export function ErrorState({ message }) {
  return (
    <Box sx={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <Typography color="error">{message}</Typography>
    </Box>
  );
}

export function EmptyProjectsState() {
  return (
    <Box sx={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', px: 3, textAlign: 'center' }}>
      <Typography color="text.secondary">No yearbook projects are available for this account.</Typography>
    </Box>
  );
}
